<template>
  <div class="home" ref="home">

    <div class="home_spinner" ref="spinner">
      Loading...
    </div>

    <div class="home_visual" ref="bg">
      <canvas
        class="home_visual_canvas"
        id="AvatarCanvas"
        width="1000"
        height="1000"
      />
    </div>

    <main class="home_container">

      <div class="home_brand">
        <h1 class="home_brand_text textAnime">tmiame</h1>
      </div>

      <div class="home_inner">
        <div class="home_bio">
          <p class="textAnime">
            √ Frontend / Design / Markup
          </p>
        </div>
        <ul class="home_links">
          <li class="textAnime">
            <a href="https://frontend.jp/" target="_blank" v-touchfeedback>Frontend.jp ↗︎</a>
          </li>
          <li class="textAnime">
            <router-link v-bind:to="{ name: 'DaysOfDesign' }" v-touchfeedback>Days of Design →</router-link>
          </li>
          <li class="textAnime disable">
            <a href="https://thisis.link/" target="_blank">This Is Link [WIP]</a>
          </li>
        </ul>
        <ul class="home_snsLinks">
          <li class="textAnime">
            <a href="https://twitter.com/tmiame" target="_blank" rel="noopener" v-touchfeedback>Twitter</a>
          </li>
          <li class="textAnime">
            <a href="https://github.com/tmiame" target="_blank" rel="noopener" v-touchfeedback>GitHub</a>
          </li>
          <li class="textAnime">
            <a href="https://qiita.com/tmiame" target="_blank" rel="noopener" v-touchfeedback>Qiita</a>
          </li>
          <li class="textAnime">
            <a href="https://dribbble.com/my" target="_blank" rel="noopener" v-touchfeedback>Dribbble</a>
          </li>
        </ul>
      </div>

    </main>
  </div>
</template>

<script>
import anime from 'animejs'
import AvatarCanvas from '@/modules/avatar-canvas.js'
import UA from '@/modules/Browser.js'
import { loadImage } from '@/helpers/utils'

const BG_IMAGE = require('@/assets/images/home_bg.jpg')

export default {
  name: 'home',

  data: () => ({
    AvatarCanvas: false
  }),

  components: {
  },

  methods: {
    /**
     * ファーストビューの高さCSSで決めるかJSで決めるか判定する
     */
    setWindowHeight() {
      if (!this.$refs.home) {
        return
      }
      if (UA.device.type === 'mobile' || UA.device.type === 'tablet') {
        this.$refs.home.style.height = `${window.innerHeight}px`
        this.$refs.home.style.minHeight = `${window.innerHeight}px`
        this.$refs.home.style.maxHeight = `${window.innerHeight}px`
        this.$refs.home.classList.remove('is-cssResize')
      } else {
        this.$refs.home.classList.add('is-cssResize')
      }
    },

    showAvatar() {
      anime({
        targets: this.$refs.spinner,
        opacity: {
          value: 0,
          duration: 500
        },
        easing: 'linear'
      })
      anime({
        targets: document.querySelectorAll('.textAnime'),
        opacity: {
          value: [0, 1],
          duration: 1500
        },
        delay: anime.stagger(75, { start: 300, easing: 'easeOutQuad' }),
        easing: 'easeInOutQuad',
        complete: () => {
          this.AvatarCanvas.animeStart()
        }
      })
    }
  },

  async mounted() {
    await loadImage(BG_IMAGE)

    this.AvatarCanvas = new AvatarCanvas('AvatarCanvas')

    this.showAvatar()
  },

  created() {
    this.setWindowHeight()
    window.addEventListener('debounceResizeViewport', this.setWindowHeight, false)
  },

  beforeDestroy() {
    window.removeEventListener('debounceResizeViewport', this.setWindowHeight, false)

    if (this.AvatarCanvas) {
      this.AvatarCanvas.destroy()
    }
  }
}
</script>
